import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["width", "height", "length", "weight", "volume"]
  static values = { 
    presets: Object,
    categoryHints: Object 
  }

  connect() {
    this.updateVolume()
  }

  // Presets rapides pour dimensions courantes
  applyPreset(event) {
    const preset = event.target.dataset.preset
    const dimensions = this.getPresetDimensions(preset)
    
    if (dimensions && this.hasWidthTarget && this.hasHeightTarget && this.hasLengthTarget && this.hasWeightTarget) {
      this.widthTarget.value = dimensions.width
      this.heightTarget.value = dimensions.height
      this.lengthTarget.value = dimensions.length
      if (dimensions.weight) this.weightTarget.value = dimensions.weight
      
      this.updateVolume()
      this.showFeedback(`Dimensions ${preset} appliquées`)
    }
  }

  // Calcul automatique du volume
  updateVolume() {
    const width = parseFloat(this.widthTarget.value) || 0
    const height = parseFloat(this.heightTarget.value) || 0 
    const length = parseFloat(this.lengthTarget.value) || 0
    
    if (width > 0 && height > 0 && length > 0) {
      const volume = ((width * height * length) / 1000).toFixed(2)
      this.showVolume(`${volume} litres`)
      
      // Suggestion de poids approximatif si vide
      if (!this.weightTarget.value) {
        this.suggestWeight(volume)
      }
    }
  }

  // Suggestions de poids basées sur le volume
  suggestWeight(volume) {
    const volumeNum = parseFloat(volume)
    let suggestedWeight = Math.round(volumeNum * 200) // Densité moyenne 200g/L
    
    if (suggestedWeight > 0 && suggestedWeight < 50000) {
      this.showWeightSuggestion(suggestedWeight)
    }
  }

  // Presets prédéfinis
  getPresetDimensions(preset) {
    const presets = {
      'livre-poche': { width: 11, height: 2, length: 18, weight: 200 },
      'livre-standard': { width: 15, height: 3, length: 23, weight: 400 },
      'a4': { width: 21, height: 0.5, length: 29.7, weight: 50 },
      'poster-a3': { width: 29.7, height: 0.1, length: 42, weight: 100 },
      'cd': { width: 12.4, height: 1, length: 12.4, weight: 50 },
      'vinyle': { width: 31.5, height: 1, length: 31.5, weight: 150 },
      'tshirt': { width: 25, height: 1, length: 35, weight: 180 },
      'poster-a2': { width: 42, height: 0.1, length: 59.4, weight: 150 }
    }
    return presets[preset]
  }

  // Feedback visuel
  showFeedback(message) {
    const feedback = this.element.querySelector('[data-dimensions-feedback]')
    if (feedback) {
      feedback.textContent = message
      feedback.classList.remove('hidden')
      feedback.classList.add('text-green-600')
      setTimeout(() => {
        feedback.classList.add('hidden')
        feedback.classList.remove('text-green-600')
        feedback.textContent = ''
      }, 3000)
    }
  }

  showVolume(volume) {
    if (this.hasVolumeTarget) {
      this.volumeTarget.textContent = `📦 Volume: ${volume}`
    }
  }

  showWeightSuggestion(weight) {
    const suggestion = this.element.querySelector('[data-weight-suggestion]')
    if (suggestion) {
      suggestion.innerHTML = `💡 Poids suggéré: <button type="button" class="text-blue-600 hover:text-blue-800 underline ml-1 transition-colors" data-action="click->dimensions#applySuggestedWeight" data-weight="${weight}">${weight}g</button>`
      suggestion.classList.remove('hidden')
    }
  }

  applySuggestedWeight(event) {
    const weight = event.target.dataset.weight
    this.weightTarget.value = weight
    event.target.parentElement.innerHTML = ''
  }

  // Event listeners pour recalcul automatique
  dimensionChanged() {
    this.updateVolume()
  }
}